var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.teacher
    ? _c(
        "SoliAvatarBtn",
        {
          staticStyle: { width: "-webkit-fill-available", overflow: "hidden" },
          attrs: {
            outlined: _vm.outlined,
            avatar: _vm.teacher.profile_photo_url,
            title: _vm.teacher.name,
            blueShadow: !_vm.blueBorder,
            blue: _vm.blueBorder,
            size: _vm.size,
            moreInfo: !!(_vm.expand && _vm.teacher.bio),
            disabled: _vm.disabled,
            subtitleBottom: `${
              _vm.teacher.pronouns ? _vm.teacher.pronouns + " | " : ""
            }${
              _vm.teacher.instruments.length > 3
                ? _vm.teacher.instruments
                    .filter((e, idx) => 3 > idx)
                    .map((i) => " " + i.name) + "..."
                : _vm.teacher.instruments.map((i) => " " + i.name)
            }`,
          },
          on: {
            click: function ($event) {
              ;[_vm.$emit("input", _vm.teacher), (_vm.dialog = true)]
            },
          },
        },
        [
          [
            _vm.teacher.certification_level
              ? _c("SoliTeacherCert", { attrs: { teacher: _vm.teacher } })
              : _vm._e(),
          ],
          _vm._v(" "),
          _vm.selectedInstrument
            ? _c("TeacherInfo", {
                attrs: {
                  teacher: _vm.teacher,
                  selectedInstrument: _vm.selectedInstrument,
                },
                on: {
                  close: function ($event) {
                    _vm.dialog = false
                  },
                },
                model: {
                  value: _vm.dialog,
                  callback: function ($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog",
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }